import { AuthGuard } from './../shared/services/auth-guard.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProfileComponent } from './profile.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ProfileContactFormComponent } from './profile-contact-form/profile-contact-form.component';
import { AccountFormComponent } from './account-form/account-form.component';

const routes: Routes = [
  {
    path: '',
    data: { breadcrumb: "Profile" },
    component: ProfileComponent,
    canActivate: [AuthGuard],
    children:[
      {
        path: 'change-password',
        data: { breadcrumb: 'Change Password' },
        component: ChangePasswordComponent
      },
      {
        path: 'contact',
        data: { breadcrumb: 'Contact Detail' },
        component: ProfileContactFormComponent
      },
      {
        path: 'account',
        data: { breadcrumb: 'Contact Detail' },
        component: AccountFormComponent
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfileRoutingModule { }
